import { TraitCard } from "@components/cards/TraitCard"
import { TraitResponse } from "baaanggg"

type Props = {
    traits: TraitResponse[]
}

export function TraitsTab({ traits }: Props) {
    return <div
        className="rounded-t-2lg rounded-b-2lg rounded-tl-none border border-jacarta-100 bg-white p-6 dark:border-gray-400 dark:bg-gray-900 md:p-10">
        <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4">
            {
                traits?.map(trait => <TraitCard key={trait.id} name={trait.traitType} value={trait.value} />)
            }
        </div>
    </div>
}